import { defineStore } from 'pinia';

import { getFaqPageId } from '@/service';

export const useGlobalStore = defineStore('global', {
  state: () => ({
    fontSize: 1 as number, // 1 = normal, 2 = large, 3 = extra large
    faqPageId: 0 as number,
  }),
  getters: {
    getFontSize: (state) => state.fontSize,
  },
  actions: {
    setFontSize(size: number) {
      this.fontSize = size;
    },
    async fetchFaqPageId() {
      const response = await getFaqPageId();
      if (response.data && response.data.page_id) {
        this.faqPageId = response.data.page_id;
      }
    },
  },
});
